var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"multi-data-select-add-icon button add-button",staticStyle:{"min-width":"20px"}},[_c('Icon',{attrs:{"type":"mdi","path":_vm.icons.mdiPlus,"size":16}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }